import type { PortfolioRiskLevel } from './project-portfolio-report.model';
import type { ProjectStatus } from './project.model';

/**
 * Project-detail drilldown (spec: project-portfolio-reporting.md, Story 3).
 *
 * Read-only aggregation, scoped to exactly one project's OWN bookings (no
 * hierarchy roll-up — consistent with the portfolio table, Story 1). Reuses
 * the same forecast/ampel formulas as the portfolio row plus a
 * "Beteiligte Personen" breakdown over the same rolling window as Story 2.
 */

export interface ProjectDetailProject {
  id: string;
  number: string;
  name: string;
  customer: string | null;
  status: ProjectStatus;
}

export interface ProjectDetailPersonRow {
  personId: string;
  firstName: string;
  lastName: string;
  /** Actual hours per month, aligned with `ProjectDetailReport.months`. */
  hoursByMonth: number[];
}

export interface ProjectDetailReport {
  project: ProjectDetailProject;
  budgetHours: number | null;
  actualHours: number;
  forecastHours: number;
  /** `false` when `startDate`/`endDate` is missing — `forecastHours` is then not an extrapolation. */
  hasForecastPeriod: boolean;
  /** `budgetHours - actualHours`; `null` when `budgetHours` is `null`. May be negative (already over budget). */
  remainingBudgetHours: number | null;
  /** Extrapolated billable hours × the effective cost rate; `null` without a resolvable rate. */
  forecastRevenue: number | null;
  /** The project's own default rate, else the global default, else `null`. */
  effectiveRate: number | null;
  riskLevel: PortfolioRiskLevel;
  riskReasons: string[];
  /** Same rolling window as Story 2 (ascending `YYYY-MM`, oldest first). */
  months: string[];
  /** Every person with at least one booking on the project, ordered by last/first name. */
  team: ProjectDetailPersonRow[];
}
